import { useState } from 'react';
import { GetPeoplePerson } from '../../utils/CommonTypes/PeoplePageTypes';
import Icon, { IconType } from '../Icon/Icon';
import Modal from '../Modal/Modal';
import { toast } from 'react-toastify';
import { store } from '../../redux/oldStore';
import { ServerResponse } from '../../utils/Server';

interface IProps {
  selected: Record<string, boolean>;
  setSelected: (selected: Record<string, boolean>) => void;
  people: GetPeoplePerson[];
  refresh: () => void;
  canRemove: boolean;
}

interface IBulkDeleteResult {
  PersonId: string;
  Success: boolean;
  Message: string;
}

const BulkDelete = (props: IProps) => {
  const [showConfirm, setShowConfirm] = useState<boolean>(false);
  const [deleting, setDeleting] = useState<boolean>(false);

  const selectedIds = Object.keys(props.selected).filter((id) => props.selected[id]);
  const selectedPeople = props.people.filter((x) => selectedIds.includes(x.Id));

  if (!props.canRemove || selectedIds.length === 0) return null;

  const confirmDelete = () => {
    toast.clearWaitingQueue();
    setDeleting(true);

    let request = {
      people: selectedPeople.map((x) => {
        return { personId: x.Id, projectKey: x.ProjectKey };
      }),
    };

    store.server.postApi<ServerResponse<IBulkDeleteResult[]>>('../Person/BulkDelete', request).then((x) => {
      setDeleting(false);
      setShowConfirm(false);

      if (x.Success) {
        toast.success(`${selectedIds.length} selected people deleted!`);
      } else {
        toast.error(x.Message, { autoClose: false });
      }

      props.setSelected({});
      props.refresh();
    });
  };

  return (
    <>
      <button type="button" className="btn btn-danger btn-xs" onClick={() => setShowConfirm(true)} title="Delete selected people">
        <Icon type={IconType.delete} /> Delete
      </button>

      {showConfirm && (
        <Modal setModalOpen={setShowConfirm} title="Delete Selected People" size="m">
          <p>
            Are you sure you want to delete {selectedIds.length} selected people? This action cannot be undone.
          </p>
          <div className="flex-between">
            <button type="button" className="btn btn-default" onClick={() => setShowConfirm(false)} disabled={deleting}>
              Cancel
            </button>
            <button type="button" className="btn btn-danger" onClick={confirmDelete} disabled={deleting}>
              <Icon type={IconType.delete} /> Delete
            </button>
          </div>
        </Modal>
      )}
    </>
  );
};

export default BulkDelete;
